import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "../../../helpers/pipes/pipes.module";
import { TimePickerPopoverComponent } from "./time-picker-popover.component";

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA], // Pour Swiper.Js
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild([
            {
                path: "",
                component: TimePickerPopoverComponent,
            },
        ]),
        PipesModule,
        TranslateModule,
    ],
    declarations: [TimePickerPopoverComponent],
    providers: [],
})
export class TimePickerPopoverModule {
}
